import { CommonModule } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideClientHydration } from '@angular/platform-browser';
import { SsrCookieService } from 'ngx-cookie-service-ssr';
import { TokenInterceptor } from './TokenInterceptor';

@NgModule({
  exports: [CommonModule, FormsModule, ReactiveFormsModule],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  providers: [
    SsrCookieService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    provideClientHydration(),
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class SharedModule {}
